module.exports = __webpack_public_path__ + "fonts/iconfont.7a3f5f20.ttf";